/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { AbstractSnapshotFormComponent, FormState, FormStateBuilder, FormStateSnapshot } from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, FormMode } from '@gh/core-ui';
import { LeadDetailsBusinessService } from '../../../';
import { SfCompletionAuthorization } from '../../../resources/lead.model';

@Component({
  selector: 'gh-complete-sale-authorization-step',
  template: require('./complete-sale-authorization-step.component.html'),
})
export class CompleteSaleAuthorizationStepComponent
  extends AbstractSnapshotFormComponent<SfCompletionAuthorization>
  implements OnInit {

  constructor(private formStateBuilder: FormStateBuilder,
              private business: LeadDetailsBusinessService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  loadBaseDesigns(event: AutocompleteLoadMoreEvent): void {
    event.load(this.business.findAllBaseDesignsByName(event.query));
  }

  // tslint:disable-next-line:max-line-length
  protected buildForm(snapshot: FormStateSnapshot<SfCompletionAuthorization>): FormState<SfCompletionAuthorization> {
    return this.formStateBuilder.buildPlain({
      snapshot,
      mode: FormMode.EditMode,
      children: {
        code: { enabled: false },
        description: void 0,
        baseDesign: { required: true },
        contractPrice: { enabled: false },
        memo: void 0,
      },
    });
  }
}
